<template>

    <footer v-if="!agency">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-4">
                    <div class="nav flex-column">
                        <div class="nav-item"><span class="nav-title">{{ $t('labels.product') }}</span></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('signup')">{{ $t('labels.start_free_trial') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('login')">{{ $t('labels.log_in') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('pricing')">{{ $t('labels.pricing') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://moregoodreviews.com/showcase/moregoodreviews" target="_blank">{{ $t('labels.our_reviews') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://status.moregoodreviews.com" target="_blank"><i class="fas fa-signal-stream mr-5"></i>{{ $t('labels.status') }}</a></div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="nav flex-column">
                        <div class="nav-item"><span class="nav-title">{{ $t('labels.company') }}</span></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('contact')">{{ $t('labels.contact_us') }}</a></div>
                        <div class="nav-item"><a class="nav-link" :href="$feedbackUrl" target="_blank">{{ $t('labels.roadmap') }}</a></div>
                        <div class="nav-item"><a class="nav-link" :href="`${$feedbackUrl}/changelog`" target="_blank">{{ $t('labels.changelog') }}</a></div>
                        <div class="nav-item"><a class="nav-link" :href="$docsUrl" target="_blank">{{ $t('labels.documentation') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://discord.gg/9vvND2FygJ" target="_blank">{{ $t('labels.discord_community') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://blog.moregoodreviews.com" target="_blank">{{ $t('labels.blog') }}</a></div>
                    </div>
                </div>
                <div class="col-12 col-md-4">
                    <div class="nav flex-column">
                        <div class="nav-item"><span class="nav-title">{{ $t('labels.policies') }}</span></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('terms')">{{ $t('labels.terms_of_service') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('privacy')">{{ $t('labels.privacy_policy') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('cookies')">{{ $t('labels.cookie_policy') }}</a></div>
                        <div v-if="cookieConsentEnabled" class="nav-item"><a class="nav-link" href="#" @click.prevent="openCookiePreferences">{{ $t('labels.cookie_preference') }}</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('sub-processors')">{{ $t('labels.sub_processors') }}</a></div>
                        <div class="nav-item">
                            <a class="nav-link" href="#" @click.prevent="push('dpa')">{{ $t('labels.dpa') }}</a> · <a class="nav-link" href="#" @click.prevent="push('dsar')">{{ $t('labels.dsar') }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <span class="fs-10">© {{ year }} SJW Group, Inc.</span>
                </div>
            </div>
        </div>
    </footer>

    <footer v-else-if="agency">
        <div class="container">
            <div class="row">
                <div class="col">
                    <span class="name mb-5">{{ agency.name }}</span>
                    <span class="mb-5" v-if="agency.footer" v-html="agency.footer" />
                    <span class="fs-10">© {{ year }}</span>
                </div>
            </div>
        </div>
    </footer>

</template>

<style scoped lang="scss">

    footer {
        @include font-medium(12px);
        background: $color-bg;
        color: $color-text;
        line-height: 1.6em;
        padding: 60px 0;
        text-align: center;
        span {
            color: $color-text;
            display: block;
            &.name {
                @include font-semibold(12px);
            }
            a {
                color: $color-text;
                transition: opacity .3s;
                &:hover {
                    opacity: 0.5;
                }
            }
        }
    }

    .nav {
        text-align: center;
        margin: 0 0 30px 0;
        .nav-item {
            margin: 0 0 10px 0;
            padding: 0;
        }
        .nav-title {
            @include font-semibold(14px);
            color: $color-text;
            line-height: 1.4em;
            margin: 0 0 5px 0;
        }
        .nav-link {
            @include font-medium(13px);
            display: inline;
            line-height: 1.4em;
            padding: 0;
        }
    }

</style>

<script>

import ConsentUtil from '@utils/ConsentUtil';
import moment from 'moment';

export default {

    data() {
        return {
            year: moment().format('Y'),
        }
    },

    computed: {

        apiKey() {
            return this.$store.getters.apiKey;
        },

        agency() {
            return this.$store.getters.agency;
        },

        cookieConsentEnabled() {
            return ConsentUtil.isRequired();
        },

    },

    methods: {

        push(name) {
            if (this.$route.name !== name) {
                this.$router.push({ name: name });
            }
        },

        openCookiePreferences() {
            this.$store.commit('setModal', 'cookie-preferences');
        },

    },

}

</script>